<template>
  <div>
    <img src="../assets/my/2025.png" style="height:120px;"/>
    	<div id="wrapper">
    		<div id="content" style="height:690px;">
    			<p style="font-size:large; float:none;">
    				<strong>
    				    Contact
    				</strong>
    			</p>
    			<p>
    				<!-- For general inquiries, please contact <a href="mailto:idasbworkshop@gmail.com">idasbworkshop@gmail.com</a>, or workshop co-chairs. -->

            Further information can be found at the workshop website (running at three sites in USA, China, and UK)
    			</p>
          <p>
            1.	The workshop website will be alive when the proposal is accepted.
            

          </p>
          <p>
            2.The selected papers will be published in a special issue in IJCBDD, as we did in the past ten years.
          </p>
    		</div>
    	</div>
      <footer-component></footer-component>

  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>
</style>
